module.exports = __webpack_public_path__ + "static/don40-c325d2b2e82b699e6233d5b4ef5eed15.jpg";